module.exports = {
      id: "search-usage",
      viewBox: "0 0 20 20.051",
      url: "/" + "sprite-830c6fc89c6e575b53718d760c90aee8.svg#search",
      toString: function () {
        return this.url;
      }
    }